import { Button, Grid, Typography } from "@mui/material"
import { OneSwitch } from "../../../Components/OneSwitch/OneSwitch"
import { useContext, useEffect, useState } from "react"
import { showNotify } from "../../../Utils/Utils"
import { WebSocketContext } from "../../../Providers/WebSocket/WebSocketContext"
import OneInput from "../../../Components/OneInput/OneInput"
import { delay, container, box, rows, fieldset, oini, button } from "./sxGlobalConfigSx"

const GlobalConfig = () => {
    const { addRoute, sendWs } = useContext(WebSocketContext)
    const [formData, setFormData] = useState()
    const [initialData, setInitialData] = useState(null)

    useEffect(() => {
        addRoute('getTempoMaxGravacaoVMS', getTempoMaxGravacaoVMS)
        sendWs('getTempoMaxGravacaoVMS', {})
    }, [])

    const handleSubmit = (event) => {
        event.preventDefault()

        if (!formData || Object.keys(formData).length == 0) {
            showNotify("warning", "Nenhuma alteração feita!")
            return false
        }

        let info = formData

        if (info.hasOwnProperty('obrigatorio_tag_oini')) {
            global.obrigatorio_tag_oini = info.obrigatorio_tag_oini
            info.obrigatorio_tag_oini = info.obrigatorio_tag_oini ? 1 : 0
        }

        if (info.hasOwnProperty('delay_req_dguard')) {
            if (info.delay_req_dguard <= 1000) {
                info.delay_req_dguard = formData.delay_req_dguard
            } else {
                showNotify("warning", "Valor máximo do delay permitido é 1000")
                return false
            }
        }

        sendWs("UpdateConfigGlobal", { info })
        addRoute("UpdateConfigGlobal", responseSubimit)
    }

    const responseSubimit = (msg) => {
        if (msg.data.status) {
            showNotify("success", "Configurações salvas com sucesso!")
        } else if (!msg.data.status) {
            showNotify("error", "Erro a salvar as configurações")
        }
    }

    let mostrarMsg = false

    const handleChange = (event) => {
        if (event.target.value != undefined) {
            // validação do input do delay, caso for maior que 1000, ele seta o valor invalido para 1000
            if (event.target.name == 'delay_req_dguard' && event.target.value > 1000 && event.target.value !== '') {
                if (!mostrarMsg) {
                    showNotify("warning", "Valor máximo do delay permitido é 1000")
                    event.target.value = "1000"
                    setFormData({ ...formData, [event.target.name]: "1000" })
                    mostrarMsg = true
                }
                return
            }

            if (event.target.type == 'checkbox') {
                setFormData({ ...formData, [event.target.name]: event.target.checked })
            } else {
                setFormData({ ...formData, [event.target.name]: event.target.value })
            }
        }
    }

    const getTempoMaxGravacaoVMS = (msg) => {
        console.log(msg)
        const { status, data: tempo_max_gravacao_vms, message } = msg.data

        console.log('TESTE: ', tempo_max_gravacao_vms)

        if (!status && message) {
            return showNotify("error", message)
        }

        setInitialData({ ...initialData, tempo_max_gravacao_vms })
    }

    return (
        <Grid xs={12} sx={container} flexDirection="column" rowGap={1} >
            <Grid sx={box}>
                <Grid sx={rows} >
                    <fieldset style={fieldset}>
                        <legend style={{ color: 'black' }}>Configurações Gerais</legend>

                        <Grid container xs={12} md={12} lg={12} sx={oini}>
                            <Grid xs={1} sm={0.7} md={0.5} lg={0.4} xl={0.3} >
                                <OneSwitch
                                    onChange={handleChange}
                                    defaultValue={global.obrigatorio_tag_oini}
                                    name={"obrigatorio_tag_oini"}
                                />
                            </Grid>
                            <Grid xs={11} sm={10} md={10} lg={10} xl={10}>
                                <Typography fontSize="15px" fontWeight='400' > Obrigar inserção de tag de atendimento para evento OINI </Typography>
                            </Grid>
                        </Grid>

                        <Grid container xs={12} md={12} lg={12} sx={delay}>
                            <Grid xs={2} sm={1.3} md={0.8} lg={0.7} xl={0.5} >
                                <OneInput
                                    type="number"
                                    newSx={{ width: '65px' }}
                                    defaultValue={global.delay_req_dguard}
                                    onChange={handleChange}
                                    name={"delay_req_dguard"}
                                />
                            </Grid>
                            <Grid xs={10} sm={10} md={10} lg={10} xl={10}>
                                <Typography fontSize="15px" fontWeight='400' >Delay <b>em milisegundos</b> entre requisições do Dguard </Typography>
                            </Grid>

                        </Grid>

                        {initialData && initialData.hasOwnProperty('tempo_max_gravacao_vms') &&
                            <Grid container xs={12} md={12} lg={12} sx={delay}>
                                <Grid xs={2} sm={1.3} md={0.8} lg={0.7} xl={0.5} >
                                    <OneInput
                                        type="number"
                                        newSx={{ width: '65px' }}
                                        defaultValue={initialData?.tempo_max_gravacao_vms}
                                        onChange={handleChange}
                                        name={"tempo_max_gravacao_vms"}
                                    />
                                </Grid>
                                <Grid xs={10} sm={10} md={10} lg={10} xl={10}>
                                    <Typography fontSize="15px" fontWeight='400' >Tempo máximo <b>em minutos</b> para a gravação de imagens de um evento no VMS Digifort/Dguard (somente eventos que vão para a tela). <br /> Deixe vazio se não há limite.</Typography>
                                </Grid>

                            </Grid>
                        }

                    </fieldset>
                </Grid>
                <Grid sx={button}>
                    <Button color="one_primary" variant="contained" form="eventos-form" onClick={handleSubmit}>Salvar</Button>
                </Grid>

            </Grid>
        </Grid>
    )
}

export default GlobalConfig
